module.exports = __webpack_public_path__ + "img/subject_07_106.jpg";